{
    "convercusProgramId": "gkr",
    "integration": "gkr",
    "platform": "ios",
    "levelKey": "Regular",
    "appearance": {
        "balanceName": "Beer Thaler",
        "icon": "https://example.com/gkr-icon.png",
        "passLogo": "",
        "bannerImage": "",
        "backgroundColor": "#1a1a1a",
        "foregroundColor": "#ffffff"
    },
    "scannableCode": {
        "type": "qr",
        "previewMessage": "gkr-acc-demo-001"
    },
    "mockPayload": {
        "name": "",
        "balance": 1250,
        "balanceDisplay": "12,50",
        "tierStatus": "Regular"
    },
    "apple": {
        "omitPointsAndBalanceSemantics": false,
        "headerFields": [
            {
                "key": "balance",
                "label": "Beer Thaler",
                "value": "12,50"
            }
        ],
        "secondaryFields": [
            {
                "key": "tier",
                "label": "Tier",
                "value": "Regular"
            }
        ],
        "auxiliaryFields": [],
        "barcodeAltText": "\u200b"
    },
    "google": {
        "omitPrimaryLoyaltyPoints": false,
        "issuerName": "\u200b",
        "programName": "\u200b",
        "loyaltyPointsLabel": "Beer Thaler",
        "loyaltyPointsBalance": "12,50",
        "secondaryLoyaltyPointsLabel": "Tier",
        "secondaryLoyaltyPointsBalance": "Regular",
        "textModules": [],
        "barcodeAlternateText": "\u200b"
    }
}
